import { twMerge } from 'tailwind-merge';

import { Button } from '../button';

interface BurgerButtonProps {
  isOpen: boolean;
  className?: string;
  onClick: () => void;
}

export const BurgerButton = ({
  isOpen,
  onClick,
  className,
}: BurgerButtonProps) => {
  return (
    <Button
      variant="text"
      onClick={onClick}
      className={twMerge(
        'flex h-6 w-6 min-w-0 items-center justify-center rounded-full',
        className
      )}
    >
      <div className="flex flex-col space-y-1">
        <div
          className={twMerge(
            'h-0.5 w-5 bg-gray-600 transition-all duration-200',
            isOpen && 'translate-y-1.5 rotate-45'
          )}
        />
        <div
          className={twMerge(
            'h-0.5 w-5 bg-gray-600 transition-all duration-200',
            isOpen && 'opacity-0'
          )}
        />
        <div
          className={twMerge(
            'h-0.5 w-5 bg-gray-600 transition-all duration-200',
            isOpen && '-translate-y-1.5 -rotate-45'
          )}
        />
      </div>
    </Button>
  );
};
